import { combineReducers } from '@reduxjs/toolkit';
import chatUIReducer from './chatSlice';
import selectedContentReducer from './selectedContentSlice';

export { default as tabsSlice } from './tabsSlice';
export * from './selectedContentSlice';

// Combine chat-related reducers under a single 'chat' namespace
export const chatSlice = combineReducers({
    ui: chatUIReducer,
    selectedContent: selectedContentReducer,
});
